import { render } from "./Teble4goodtable.vue?vue&type=template&id=024bae5b&scoped=true&ts=true"
import script from "./Teble4goodtable.vue?vue&type=script&lang=ts"
export * from "./Teble4goodtable.vue?vue&type=script&lang=ts"

import "./Teble4goodtable.vue?vue&type=style&index=0&id=024bae5b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024bae5b"]])

export default __exports__